import { render } from "./DebugULMenu.vue?vue&type=template&id=2ce10129&scoped=true"
const script = {}

import "./DebugULMenu.vue?vue&type=style&index=0&id=2ce10129&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce10129"]])

export default __exports__